<template>
  <div>
    <div class="min-vh-100">
      <c-row class="no-gutters px-3 px-sm-0">
        <b-col xl="4" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">รายการ Signature</h1>
        </b-col>
        <b-col lg="8" class="text-right">
          <b-row class="no-gutters d-flex justify-content-end">
            <b-button @click="openModalSignature" class="btn-main"
              >เพิ่ม</b-button
            >
          </b-row>
        </b-col>
      </c-row>

      <div class="mt-4 bg-white px-0 pb-3">
        <b-row class="no-gutters">
          <b-col>
            <b-table
              class="table-list"
              striped
              responsive
              hover
              :items="items"
              :fields="fields"
              :busy="isBusy"
              :per-page="perPage"
              show-empty
              empty-text="ไม่พบข้อมูล"
            >
              <template v-slot:cell(no)="data">
                {{ data.index + 1 }}
              </template>
              <template v-slot:cell(action)="data">
                <div class="text-center">
                  <b-button
                    variant="link"
                    class="text-dark px-1 py-0"
                    @click="openModalSignature(data.item)"
                  >
                    แก้ไข
                  </b-button>
                  <b-button
                    variant="link"
                    @click="deleteData(data.item.id)"
                    class="text-dark px-1 py-0"
                  >
                    ลบ
                  </b-button>
                </div>
              </template>
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template></b-table
            >
          </b-col>
        </b-row>
      </div>
    </div>
    <!-- Modal -->
    <ModalAlertConfirm
      msg="ยืนยันการลบ ?"
      :text="modalMessage"
      btnConfirm="ลบ"
      colorBtnConfirm="danger"
      btnCancel="ยกเลิก"
      ref="ModalAlertConfirm"
      @confirm="btnDelete"
    />
    <ModalAlert ref="modalAlert" :text="modalMessage" />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
    <ModalSingature ref="ModalSingature" @handleData="onSubmit" />
  </div>
</template>

<script>
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalSingature from "@/views/pages/signature/components/ModalSingature";

export default {
  name: "Signature",
  components: {
    ModalAlertConfirm,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
    ModalSingature,
  },
  data() {
    return {
      modalMessage: "",
      formDelete: {
        id: "",
      },
      perPage: 10,
      fields: [
        {
          key: "no",
          label: "#",
          class: "w-100px",
        },
        {
          key: "name",
          label: "ชื่อ",
          class: "w-100px",
        },
        {
          key: "position",
          label: "ตำแหน่ง",
          class: "w-100px",
        },
        {
          key: "action",
          label: "",
        },
      ],
      items: [],
      rows: 10,
      isBusy: false,
    };
  },
  created: async function () {
    this.$isLoading = false;
    await this.getList();
    this.$isLoading = true;
  },
  methods: {
    openModalSignature(item) {
      this.$refs.ModalSingature.show(item);
    },
    async getList() {
      this.isBusy = true;
      let resData = await this.$callApi(
        "get",
        `${this.$baseUrl}/api/signature`,
        null,
        this.$headers,
        null
      );

      this.isBusy = false;
      if (resData.result == 1) {
        this.items = resData.detail;
        this.rows = resData.detail.length;
      }
    },
    async btnDelete() {
      this.$refs.ModalAlertConfirm.hide();
      let resData = await this.$callApi(
        "delete",
        `${this.$baseUrl}/api/signature/${this.formDelete.id}`,
        null,
        this.$headers,
        null
      );

      if (resData.result == 1) {
        this.modalMessage = "สำเร็จ";
        this.$refs.modalAlert.show();
        setTimeout(async () => {
          this.$refs.modalAlert.hide();
          await this.getList();
        }, 2000);
      } else {
        this.modalMessage = resData.message;
        this.$refs.modalAlertError.show();
        setTimeout(() => {
          this.$refs.modalAlertError.hide();
        }, 2000);
      }
    },
    deleteData(id) {
      this.modalMessage = "คุณต้องการลบรายการใช่หรือไม่?";
      this.$refs.ModalAlertConfirm.show();
      this.formDelete.id = id;
    },

    async onSubmit(form) {
      let payload = {
        id: form.id ? form.id : 0,
        name: form.name,
        position: form.position,
      };

      this.$refs.modalLoading.show();
      let respData = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/signature`,
        null,
        this.$headers,
        payload
      );

      this.$refs.modalLoading.hide();
      if (respData.result == 1) {
        this.modalMessage = "สำเร็จ";
        this.$refs.modalAlert.show();
        setTimeout(async () => {
          this.$refs.modalAlert.hide();
          await this.getList();
        }, 2000);
      } else {
        this.modalMessage = respData.message;
        this.$refs.modalAlertError.show();
        setTimeout(() => {
          this.$refs.modalAlertError.hide();
        }, 2000);
      }
    },
  },
};
</script>
